import{jsxs as e,Fragment as t,jsx as r}from"react/jsx-runtime";import{styled as n}from"styled-components";import{InputNumberInFieldBody as o}from"../../flat/InputNumber/InputNumber.mjs";import{useItemNames as i}from"../../../../domain/hooks/useItemName.mjs";import{explanationName as a}from"../../../../domain/domain/UI/Explanation.name.mjs";import{leaveInteger as c}from"../../../../utils/FormatNumber.mjs";import{Numeric as l}from"../../../../domain/item/Numeric.mjs";const p=n.div`
  cursor: pointer;
  width: 24px;
  height: 30px;
  margin: 0px 5px;
  float: left;

  &:hover {
    width: 22px;
    height: 25px;
    border-top: 1px solid #ffffff;
    border-left: 1px solid #ffffff;
    border-right: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
  }
`,s=n(p)`
  background: url(images/${({$isLoading:e})=>e?"loading.png":"refresh.gif"})
    no-repeat scroll center center transparent;
`,m=n(p)`
  background: url(images/prev.png) no-repeat scroll center center transparent;
`,d=n(p)`
  background: url(images/next.png) no-repeat scroll center center transparent;
`,g=n.div`
  border-left: 1px solid #cccccc;
  border-right: 1px solid #ffffff;
  float: left;
  height: 28px;
  margin: 1px;
`,h=n.div`
  display: flex;
  justify-content: center;
  position: relative;
  height: 30px;
  float: left;
`,x=n.div`
  position: relative;
  margin-top: 6px;
  margin-left: 5px;
  width: 250px;
  height: 20px;
  float: left;
  background: transparent;
`;function f({page:n,setPage:p,loading:f,rowsPerPage:u,totalNumber:b,changePage:N}){const v=i(a),w=Math.ceil(b/u),k=10*w.toString().length,y=w<=1,j=e=>e<=w&&e>=1,I=async e=>{j(e)&&await N(e)};return e(t,{children:[!y&&e(t,{children:[r(m,{className:"grid-command prev",title:v("toPrevPage"),onClick:async()=>{await I(+c(n.current)-1)}}),r(g,{className:"separator"}),r(d,{className:"grid-command next",title:v("toNextPage"),onClick:async()=>{await I(+c(n.current)+1)}}),r(g,{className:"separator"})]}),r(s,{$isLoading:f,className:"grid-command refresh",title:v("updateLatestInfo"),onClick:async()=>{await I(+c(n.current))}}),!y&&e(t,{children:[e(h,{style:{width:2*k+60+"px"},children:[r(o,{obj:n,setObj:p,prop:"current",itemAttribute:l.of(1,w,0),extraBlurHandler:()=>{if(!Number.isInteger(+n.current))return void p({...n,current:n.prev});const e=+c(n.current);j(e)?I(e):p({...n,current:n.prev})},fieldBodyStyle:{width:`${k}px`,margin:"4px 0 2.5px",height:"20px"},innerComponentStyle:{width:`${k}px`,minWidth:`${k}px`,height:"16px",lineHeight:"18px"}}),e("div",{style:{height:"24px",padding:"5.8px 0 0.2px",font:"1.2em Consolas",lineHeight:"20px"},children:[" / ",w.toLocaleString()]})]}),r(g,{className:"separator"})]}),e(x,{children:["(",b.toLocaleString()," 件)"]})]})}const u=n(p)`
  background: url('../../../images/zoom-out.png') no-repeat scroll center left transparent;
  position: absolute;
  right: 0px;
  width: 72px;
  text-align: right;

  &:hover {
    width: 72px;
  }
`,b=n(p)`
  background: url('../../../images/zoom-in.png') no-repeat scroll center left transparent;
  position: absolute;
  right: 0px;
  width: 50px;
  text-align: right;

  &:hover {
    width: 50px;
  }
`,N=n.div`
  text-align: right;
  margin-top: 4px;
  line-height: 23px;
`;function v({isZoomedIn:e,setIsZoomedIn:t}){const n=i(a);return e?r(u,{className:"grid-command zoom-out",title:n("undo"),onClick:()=>t(!1),children:r(N,{className:"zoom-text",children:n("undo")})}):r(b,{className:"grid-command zoom-in",title:n("expansion"),onClick:()=>t(!0),children:r(N,{className:"zoom-text",children:n("expansion")})})}export{f as Paging,v as ZoomButton};
